import React from 'react';
import { Form, Dropdown, Label } from 'semantic-ui-react';

import { UserSettingAllowedValues } from '../../user/constants';

export default class AgGridServiceTypePicker extends React.Component {
    state = {
        service_product_type: '',
        error: null,
    };

    componentWillMount() {
        this.setPremises(this.props.value.split(','));
    };

    getValue() {
        return this.state.service_product_type.join(',');
    };

    isPopup() {
        return true;
    };

    setPremises = (service_product_type) => {
        if (!service_product_type || service_product_type.length < 1) {
            return this.setState({ error: 'Must select at least one value' });
        }

        this.setState({ service_product_type, error: null });
    };

    handleChange = (service_product_type) => {
        this.setState({ service_product_type }, () => this.props.api.stopEditing());
    };

    render() {
        return (
            <div className="ag-grid-editor-segment">
                <Form>
                    <Form.Field>
                        <label>Products</label>

                        <Dropdown
                            selection
                            fluid={true}
                            multiple={true}
                            value={this.state.service_product_type}
                            onChange={(e, data) => this.setPremises(data.value)}
                            options={UserSettingAllowedValues.SERVICE_PRODUCT_TYPE.map(type => ({
                                key: type, value: type, text: type
                            }))}
                        />
                        
                        {!!this.state.error && (
                            <Label basic color='red' pointing>
                                { this.state.error }
                            </Label>
                        )}
                    </Form.Field>
                </Form>
            </div>
        );
    }
}